import { useHistory } from "react-router-dom";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { Reports } from "../../../Component/Model/Dto/Advisory/Employee";
import { TableColumn } from "../../../Component/Model/Table/Table";
import { Typography } from "@mui/material";
import { useRecoilCallback } from "recoil";
import { AdvisoryReportAtom } from "../../../State/Advisory/AdvisoryReport.Atom";
import { yesNoFromBooleanFormatter } from "../../../Helpers/NumberFormatter";
import { StringDateTimeHelper } from "../../../Component/Model/helpers";



interface RegistrationAdvisorReportRows {
    id: number;
    creationDate: Date;
    scorecardName: string;
    scorecardType: string;
    isConsolidated: string
}

interface RegistrationAdvisorReportTable {
    columns: Array<TableColumn>;
    rows: Array<RegistrationAdvisorReportRows>;
}

export function AdvisoryReportsDataTable(dataObject: Reports[]): RegistrationAdvisorReportTable {
    const history = useHistory();
    const setSelectedReportId = useRecoilCallback(({ set }) => (id: number) => {
        set(AdvisoryReportAtom, { id });
    });

    const handleClick = (id: number) => {
        setSelectedReportId(id);
        history.push(`/advisory/report/:registrationId/:registrationName`);
    };
    const columns = [
        {
            Header: 'Date',
            accessor: 'creationDate',
            id: 'creationDate',
            Cell: ({ row: { original } }: any) => (
                <Typography
                    variant="caption"
                    fontWeight='regular'
                    color="#007bff"
                    component="span"
                    onClick={() => handleClick(original.id)}
                    style={{ cursor: 'pointer' }}
                >
                    {StringDateTimeHelper(original.creationDate, true)}
                </Typography>
            )
        },
        { Header: 'Scorecard Name', accessor: 'scorecardName', id: 'scorecardName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Scorecard Type', accessor: 'scorecardType', id: 'scorecardType', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Consolidated Scorecard', accessor: 'isConsolidated', id: 'isConsolidated', Cell: ({ value }: any) => <DefaultCell value={value} /> }
    ];

    if (dataObject != undefined && dataObject.length > 0) {
        const rows = dataObject.map((item: Reports) => ({
            id: item.scorecardReportId,
            creationDate: item.createdDateUTC,
            scorecardName: item.scorecardName,
            scorecardType: item.scorecardType,
            isConsolidated: yesNoFromBooleanFormatter(item.isConsolidated)

        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}

